import { useQuery, useMutation } from '@apollo/react-hooks';
import { useRef } from 'react';
import getAffiliate from '../../queries/getAffiliate';
import addAffiliate from '../../graphql/mutation/addAffiliate';
import removeAffiliate from '../../graphql/mutation/removeAffiliate';
import getImpactCookieData from './helpers/ImpactHelper';
import SoComSellerAnalytics from '../../helpers/SoCom/SoComSellerAnalytics/SoComSellerAnalytics';

const UseSyncSoComAffiliateWithBag = () => {
  const syncedAffiliate = useRef({
    loading: true,
    error: false,
    data: {},
    // syncing boolean prevents re-running graphql operations with multiple parent renders
    syncing: true,
  });

  const isSoComEnabled = !!window?.FLAGS?.SoCom;

  const {
    loading: affiliateInBagLoading,
    error: affiliateInBagError,
    data: affiliateInBagData,
  } = useQuery(getAffiliate, {
    skip: !isSoComEnabled,
  });

  const [addAffiliateSeller,
  ] = useMutation(addAffiliate, {
    onCompleted: ({ payload }) => {
      if (!payload?.successful) {
        syncedAffiliate.current.data = {};
        syncedAffiliate.current.loading = false;
        syncedAffiliate.current.error = true;

        return;
      }
      syncedAffiliate.current.data = { affiliate: { ...payload.affiliate } };
      syncedAffiliate.current.loading = false;
      syncedAffiliate.current.error = false;


      SoComSellerAnalytics('sellerAddedToBag', payload.affiliate?.id);
    },
    refetchQueries: [
      { query: getAffiliate },
    ],
  });

  const [removeAffiliateSeller,
  ] = useMutation(removeAffiliate, {
    onCompleted:
    () => {
      syncedAffiliate.current.data = {};

      syncedAffiliate.current.loading = false;

      syncedAffiliate.current.error = false;


      SoComSellerAnalytics('sellerRemovedFromBag', affiliateInBagData?.affiliate?.id);
    },
    refetchQueries: [
      { query: getAffiliate },
    ],
  });

  if (!isSoComEnabled) {
    syncedAffiliate.current.data = {};
    syncedAffiliate.current.loading = false;
    syncedAffiliate.current.error = false;
    syncedAffiliate.current.syncing = false;

    return { ...syncedAffiliate.current };
  }

  if (affiliateInBagLoading || affiliateInBagError) {
    syncedAffiliate.current.data = {};
    syncedAffiliate.current.loading = !!affiliateInBagLoading;
    syncedAffiliate.current.error = !!affiliateInBagError;

    return { ...syncedAffiliate.current };
  }

  // Impacts irclickid can be associated with all affiliates and not just style editors
  const { irclickid: impactTrackingId, ciqSharedID: socialSellerId } = getImpactCookieData();

  // nothing to sync
  if ((!socialSellerId && !impactTrackingId)
    || socialSellerId === affiliateInBagData?.affiliate?.id
  ) {
    syncedAffiliate.current.loading = false;
    syncedAffiliate.current.error = false;
    syncedAffiliate.current.data = { ...affiliateInBagData };
    syncedAffiliate.current.syncing = false;
  }

  // bag does not match cookie, sync with cookie
  if (socialSellerId
    && socialSellerId !== affiliateInBagData?.affiliate?.id?.toString()
    && syncedAffiliate.current.syncing
  ) {
    // We are no longer looking to sync seller + bag. just waiting for async operations to finish
    syncedAffiliate.current.syncing = false;
    addAffiliateSeller({
      variables: {
        input: {
          seller_id: socialSellerId,
          tracking_id: impactTrackingId,
        },
      },
    });
  }

  // If we have an affiliate tracking id and no social seller, remove the seller
  if (affiliateInBagData.affiliate.id
    && syncedAffiliate.current.syncing
    && !socialSellerId
    && impactTrackingId
  ) {
    // We are no longer looking to sync seller + bag. just waiting for async operations to finish
    syncedAffiliate.current.syncing = false;
    removeAffiliateSeller();
  }

  return { ...syncedAffiliate.current };
};

export default UseSyncSoComAffiliateWithBag;
